<div class="guild-selection-wrapper">
  <!-- Enhanced Header Section -->
  <div class="guild-selection-header">
    <div class="header-content">
      <h1 class="guild-selection-title">Manage Your Servers</h1>
      <p class="guild-selection-description">
        Select a server you want to manage!
      </p>
    </div>
  </div>

  <!-- Main Content Section -->
  <div class="guild-selection-content">
    <ng-container *ngIf="allGuilds$ | async as guilds; else loadingTemplate">
      <!-- Filter Section -->
      <div class="filter-section">
        <div class="filter-container">
          <mat-icon class="filter-icon">search</mat-icon>
          <input 
            type="text" 
            [(ngModel)]="filterText" 
            (input)="filterGuilds()" 
            placeholder="Filter guilds" 
            class="filter-input"
            aria-label="Filter guilds">
        </div>
        <button
          *ngIf="isWebsiteBotOwner"
          type="button"
          class="bot-owner-toggle"
          [class.bot-owner-toggle-active]="showAllBotGuilds"
          (click)="toggleAllBotGuilds()">
          {{ showAllBotGuilds ? 'Showing all bot servers' : 'Show all bot servers' }}
        </button>
      </div>

      <!-- Guild Cards Sections -->
      <ng-container *ngIf="filteredGuilds$ | async as guildFiltered">
        <ng-container *ngIf="guildFiltered.length > 0; else loadingTemplate">
          <div class="guild-cards-container">
            <app-guild-cards
              [helpText]="showAllBotGuilds ? '&#x1F512; Bot owner mode: these are all servers Raid Organizer is in. Servers you do not belong to open as read-only preview; servers you are in can still be edited.' : '&#x2705; Congratulations, Raid Organizer is already on your server! Start interacting now.'"
              [guilds]="interactableGuilds$ | async"
              buttonText="Let's Goooo">
            </app-guild-cards>

            <app-guild-cards
              helpText="&#x26A0; Raid Organizer is not on the server, but you are allowed to invite him. Do it now! 😄 "
              [guilds]="invitableGuilds$ | async" 
              buttonText="Invite Me" 
              (guildSelected)="botAccess($event)">
            </app-guild-cards>

            <app-guild-cards
              helpText="&#x26A0; Unfortunately Raid Organizer is not on the server, neither do you have rights to invite him. Please contact an owner or admin."
              [guilds]="notJoinableGuilds$ | async">
            </app-guild-cards>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loading-container">
    <div class="modern-loader">
      <div class="loader-orb">
        <div class="orb-core"></div>
        <div class="orb-ring orb-ring-1"></div>
        <div class="orb-ring orb-ring-2"></div>
        <div class="orb-ring orb-ring-3"></div>
      </div>
      <p class="loading-text">Loading your servers...</p>
    </div>
  </div>
</ng-template>
